import Vue from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faSquare, faEdit, faClone, faEye as farEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons"
import {
  faDesktop,
  faEye as fasEye,
  faSlidersH,
  faChevronDown,
  faChevronUp,
  faFileAlt,
  faImage,
  faQuestionCircle,
  faExternalLinkAlt,
  faTimes,
  faArrowsAltV,
  faBorderAll,
  faTrashAlt,
  faAngleDoubleDown,
  faThumbtack,
  faPlus,
  faFilePdf,
  faReply,
  faShare,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faRemoveFormat,
  faTint,
  faTintSlash,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faTextHeight,
  faListUl,
  faListOl,
  faQuoteRight,
  faLevelDownAlt,
  faInfo,
  faFileExport,
  faFileImport,
  faCloudDownloadAlt,
  faPen,
} from "@fortawesome/free-solid-svg-icons"
import { faGoogle, faYoutube } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome"

library.add(
  faSquare,
  faEdit,
  faClone,
  fasEye,
  farEye,
  faEyeSlash,
  faDesktop,
  faSlidersH,
  faChevronDown,
  faChevronUp,
  faFileAlt,
  faImage,
  faQuestionCircle,
  faExternalLinkAlt,
  faTimes,
  faArrowsAltV,
  faBorderAll,
  faTrashAlt,
  faAngleDoubleDown,
  faThumbtack,
  faPlus,
  faFilePdf,
  faReply,
  faShare,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faRemoveFormat,
  faTint,
  faTintSlash,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faTextHeight,
  faListUl,
  faListOl,
  faQuoteRight,
  faLevelDownAlt,
  faInfo,
  faFileExport,
  faFileImport,
  faGoogle,
  faYoutube,
  faCloudDownloadAlt,
  faPen,
)

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("font-awesome-layers", FontAwesomeLayers)
